import StencilHTMLElement from "./stencil-element";

class ProductQuantitySelector extends StencilHTMLElement {
  name = "ProductQuantitySelector";

  constructor() {
    super();
    this.input = null;
  }

  connectedCallback() {
    this.input = this.querySelector('input[name="quantity"]');
    
    this.minValue = parseInt(this.input.getAttribute("min")) || 1; 

    this.querySelector("#button-decrement")?.addEventListener("click", () => this.updateQuantity(-1));
    this.querySelector("#button-increment")?.addEventListener("click", () => this.updateQuantity(1));
    this.input.addEventListener("input", () => this.validateInput());
    this.input.addEventListener("blur", () => this.ensureMinimumValue());
  }

  updateQuantity(change) {
    let currentValue = parseInt(this.input.value) || this.input.min || 1;
    this.input.value = Math.max(currentValue + change, this.input.min || 1);
    this.input.dispatchEvent(new Event("change"));
  }

  validateInput() {
    this.input.value = this.input.value.replace(/[^1-9]/g, "").replace(/(\..*?)\..*/g, "$1");
  }

  ensureMinimumValue() {
    let value = parseInt(this.input.value) || this.minValue;
    if (value < this.minValue) {
      this.input.value = this.minValue;
      this.input.dispatchEvent(new Event("change"));
    }
  }
}

export default ProductQuantitySelector;